export default __webpack_public_path__ + "static/media/instaChat.d0330681.png";